import { ChevronDown } from 'lucide-react';

export interface GsSelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface GsSelectProps {
  value: string;
  onChange: (value: string) => void;
  options: GsSelectOption[];
  placeholder?: string;
  className?: string;
  ariaLabel?: string;
  disabled?: boolean;
  /**
   * 'pill' (defaut) = boite bordee arrondie + focus ring brand — toolbars de liste.
   * 'inline' = transparent, pas de bordure ni ring — le conteneur parent fournit le filet.
   */
  variant?: 'pill' | 'inline';
}

export function GsSelect({
  value,
  onChange,
  options,
  placeholder,
  className = '',
  ariaLabel,
  disabled = false,
  variant = 'pill',
}: GsSelectProps) {
  const inline = variant === 'inline';

  return (
    <div className={['relative w-full', className].filter(Boolean).join(' ')}>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={ariaLabel}
        disabled={disabled}
        className={
          inline
            ? 'w-full appearance-none bg-transparent pl-2.5 pr-8 py-2 text-field text-slate-800 dark:text-slate-100 border-0 outline-none focus:outline-none focus:ring-0 disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none'
            : 'w-full appearance-none pl-2.5 pr-8 py-2 border border-slate-200 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-800 text-field text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-brand-500/20 focus:border-brand-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none'
        }
      >
        {placeholder ? <option value="">{placeholder}</option> : null}
        {options.map((option) => (
          <option key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
      <ChevronDown
        size={inline ? 15 : 14}
        className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400"
        aria-hidden
      />
    </div>
  );
}
